import { createRouter, createWebHistory } from 'vue-router';

import MainView from './components/MainView.vue';
import PlanetDetail from './components/PlanetDetail.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { 
            path: '/', 
            component: MainView, 
            redirect: '/earth',
            children: [
                { path: ':planetId', component: PlanetDetail, props: true }
            ]
        },
        { path: '/:notFound(.*)', redirect: '/earth'}
    ]
});

export default router;